import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "language.add",
    path: `${APP_PREFIX_PATH}/language/add`,
    component: React.lazy(() => import("views/app-views/language/addLanguage")),
  },
  {
    key: "language.list",
    path: `${APP_PREFIX_PATH}/language/list`,
    component: React.lazy(() => import("views/app-views/language/LanguageList")),
  },
  {
    key: "language.edit",
    path: `${APP_PREFIX_PATH}/language/edit`,
    component: React.lazy(() => import("views/app-views/language/addLanguage")),
  },
  {
    key: "department.add",
    path: `${APP_PREFIX_PATH}/department/add`,
    component: React.lazy(() => import("views/app-views/department/addDepartment")),
  },
  {
    key: "department.list",
    path: `${APP_PREFIX_PATH}/department/list`,
    component: React.lazy(() => import("views/app-views/department/DepatmentList")),
  },
  {
    key: "department.edit",
    path: `${APP_PREFIX_PATH}/department/edit`,
    component: React.lazy(() => import("views/app-views/department/addDepartment")),
  },
  {
    key: "Report.add",
    path: `${APP_PREFIX_PATH}/report/add`,
    component: React.lazy(() => import("views/app-views/report/addReport")),
  },
  {
    key: "Report.list",
    path: `${APP_PREFIX_PATH}/report/list`,
    component: React.lazy(() => import("views/app-views/report/reportList")),
  },
   {
    key: "Report.edit",
    path: `${APP_PREFIX_PATH}/report/edit`,
    component: React.lazy(() => import("views/app-views/report/addReport")),
  },
    {
    key: "quize.add",
    path: `${APP_PREFIX_PATH}/Quize/add`,
    component: React.lazy(() => import("views/app-views/addQuize/addQuize")),
  }, {
    key: "quize.list",
    path: `${APP_PREFIX_PATH}/Quize/list`,
    component: React.lazy(() => import("views/app-views/addQuize/quizeList")),
  },
  {
    key: "quize.edit",
    path: `${APP_PREFIX_PATH}/Quize/edit`,
    component: React.lazy(() => import("views/app-views/addQuize/addQuize")),
  }, 
  {
    key: "employee.edit",
    path: `${APP_PREFIX_PATH}/Employee/edit`,
    component: React.lazy(() => import("views/app-views/addEmployee/addEmployee")),
  }, 
  {
    key: "employee.list",
    path: `${APP_PREFIX_PATH}/Employee/list`,
    component: React.lazy(() => import("views/app-views/addEmployee/employeeList")),
  }, 
  {
    key: "video.add",
    path: `${APP_PREFIX_PATH}/Video/add`,
    component: React.lazy(() => import("views/app-views/video/addVideo")),
  }, 
  {
    key: "video.list",
    path: `${APP_PREFIX_PATH}/Video/list`,
    component: React.lazy(() => import("views/app-views/video/videList")),
  }, 

];
